import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const handleLanguageChange = (newLang: 'en' | 'nl' | 'ar') => {
    setLanguage(newLang);
  };

  return (
    <div className="flex items-center space-x-1">
      <button
        onClick={() => handleLanguageChange('en')}
        className={`px-2 py-1 text-sm font-medium rounded transition-colors ${
          language === 'en'
            ? 'text-[#492A19] bg-[#F9DCAC]'
            : 'text-neutral-600 hover:text-[#492A19]'
        }`}
      >
        EN
      </button>
      <span className="text-neutral-400">|</span>
      <button
        onClick={() => handleLanguageChange('nl')}
        className={`px-2 py-1 text-sm font-medium rounded transition-colors ${
          language === 'nl'
            ? 'text-[#492A19] bg-[#F9DCAC]'
            : 'text-neutral-600 hover:text-[#492A19]'
        }`}
      >
        NL
      </button>
      <span className="text-neutral-400">|</span>
      <button
        onClick={() => handleLanguageChange('ar')}
        className={`px-2 py-1 text-sm font-medium rounded transition-colors ${
          language === 'ar'
            ? 'text-[#492A19] bg-[#F9DCAC]'
            : 'text-neutral-600 hover:text-[#492A19]'
        }`}
      >
        عربي
      </button>
    </div>
  );
};

export default LanguageSwitcher; 